import React from 'react';
import image1 from '@/main/assets/images/homepage/shutterstock_633059789.jpg';
import image2 from '@/main/assets/images/homepage/shutterstock_2284091345.jpg';
import image3 from '@/main/assets/images/homepage/mike-van-den-bos-jf1EomjlQi0-unsplash 1.png';
import image4 from '@/main/assets/images/homepage/shutterstock_2366626359.jpg';
import image5 from '@/main/assets/images/homepage/shutterstock_2074693429.jpg';
import image6 from '@/main/assets/images/homepage/asset@3x.png'

import * as S from './styles';
import TextImage from '../components/textImage/textImage';
import TextImageInsurer from './textImageInsurer/textImageInsurer';
import { getTranslateByKey } from '@/main/services/utils';

function HomePageInsurerScreen() {
  return (
    <S.Container>
      <S.FirstSection>
        <TextImageInsurer
          backgroundImage={image1}
          idImage="id-homepage-insurer-image-1"
          title={getTranslateByKey('information.homepageInsurer1')}
          description=""
          positionImage="right"
          imageProps={{
            clipBorderImage: 'bottom',
            width: '410px',
            height: '532px'
          }}
          showButton={true}
          subTitle={getTranslateByKey('information.forInsurers')}
        />
      </S.FirstSection>
      <TextImage
        backgroundImage={image2}
        idImage="id-homepage-insurer-image-2"
        title={getTranslateByKey('information.homepageInsurer2')}
        description={getTranslateByKey('information.homepageInsurer3')}
        positionImage="left"
        imageProps={{
          clipBorderImage: 'right',
          width: '530px',
          height: '340px'
        }}
      />
      <TextImage
        backgroundImage={image3}
        idImage="id-homepage-insurer-image-3"
        title={getTranslateByKey('information.homepageInsurer4')}
        description={getTranslateByKey('information.homepageInsurer5')}
        positionImage="right"
        imageProps={{
          clipBorderImage: 'right',
          width: '530px',
          height: '340px'
        }}
      />
      <TextImage
        backgroundImage={image4}
        idImage="id-homepage-insurer-image-4"
        title={getTranslateByKey('information.homepageInsurer6')}
        description={getTranslateByKey('information.homepageInsurer7')}
        positionImage="left"
        imageProps={{
          clipBorderImage: 'bottom',
          width: '440px',
          height: '430px'
        }}
      />
      <TextImage
        backgroundImage={image5}
        idImage="id-homepage-insurer-image-5"
        title={getTranslateByKey('information.homepageInsurer8')}
        description={getTranslateByKey('information.homepageInsurer9')}
        positionImage="right"
        imageProps={{
          clipBorderImage: 'bottom',
          width: '320px',
          height: '520px'
        }}
      />
    </S.Container>
  );
}

export default HomePageInsurerScreen;
